/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useRef, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';

import keygen from 'gatsby-core-theme/src/helpers/keygen';
import useWindowSize from 'gatsby-core-theme/src/hooks/useWindowSize';
import { closeOtherSelects } from 'gatsby-core-theme/src/helpers/select';
import { translate } from 'gatsby-core-theme/src/helpers/getters';
import { Context } from '~context/MainProvider';
import Tab from './tab';
import styles from './tab-list.module.scss';

// eslint-disable react/forbid-prop-types
/* eslint no-shadow: ["error", { "allow": ["items"] }] */

const TabList = ({ items, onClick, activeTab, type, gtmClass }) => {
  const { translations } = useContext(Context) || {};

  const filterBtn = useRef(null);
  const tabList = useRef(null);

  function showDropdown() {
    closeOtherSelects(tabList.current);
    tabList.current.classList.toggle(styles.show);
    filterBtn.current.classList.toggle(styles.flip);
  }
  const clickOutSide = useCallback(
    (e) => {
      if (filterBtn.current && !filterBtn.current.contains(e.target)) {
        closeOtherSelects(null);
      }
    },
    [filterBtn.current]
  );
  useEffect(() => {
    document.addEventListener('click', clickOutSide);
    return () => {
      document.removeEventListener('click', clickOutSide);
    };
  }, []);

  const [width] = useWindowSize();
  const isMobile = width < 992;

  return (
    <div className={`${styles[type]}`}>
      {type === 'providers' ? (
        <>
          <ul className={styles.headers}>
            <li>{translate(translations, 'provider', 'Provider')}</li>
            <li>{translate(translations, 'quality', 'Quality')}</li>
            <li>{translate(translations, 'price', 'Price')}</li>
          </ul>
          <ol className={styles.listProviders} data-id="select-list">
            {items.map((item, index) => {
              if (item === null) return null;
              const { label, content } = item.props;
              return (
                <Tab
                  activeTab={activeTab}
                  key={keygen()}
                  tabId={`${label}_${index}`}
                  content={content}
                  onClick={onClick}
                  type={type}
                  gtmClass={gtmClass}
                />
              );
            })}
          </ol>
        </>
      ) : (
        <>
          <button
            ref={filterBtn}
            className={`${styles.select} ${gtmClass} tabs-menu-gtm`}
            type="button"
            onClick={showDropdown}
            data-id="select-button"
          >
            {activeTab.content}
          </button>
          <ol ref={tabList} className={styles.list} data-id="select-list">
            {items.map((item, index) => {
              if (item === null) return null;
              const { label, content } = item.props;
              if (isMobile && activeTab.label && label === activeTab.label.split('_')[0])
                return null;
              return (
                <Tab
                  activeTab={activeTab}
                  key={keygen()}
                  tabId={`${label}_${index}`}
                  content={content}
                  label={label}
                  onClick={onClick}
                  toggleDropdown={showDropdown}
                  type={type}
                  gtmClass={gtmClass}
                />
              );
            })}
          </ol>
        </>
      )}
    </div>
  );
};

TabList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  onClick: PropTypes.func,
  activeTab: PropTypes.shape({
    label: PropTypes.string,
    content: PropTypes.oneOfType([PropTypes.element, PropTypes.any]),
  }),
  type: PropTypes.oneOf(['calendar', 'providers']),
  gtmClass: PropTypes.string,
};

export default TabList;
